import {z} from 'zod';

export const FeatureSchema = z.enum(['deep_scans']);
export const FeaturesSchema = z.object({
    deep_scans: z.object({
        maxCredits: z.coerce.number()
    }).optional()
});

export type Feature = z.infer<typeof FeatureSchema>;
export type Features = z.infer<typeof FeaturesSchema>;
